import { t } from 'i18next'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { isInRevenueAllowedCountry } from '@/features/authorization/permissionHandlers/revenuePermissions'
import { SiteRevenueContent } from '@/features/site/components/revenue/SiteRevenueContent'
import { useRevenueTabsData } from '@/features/site/hooks/useRevenueTabsData'
import { SiteDetailsRouteInformation } from '@/features/site/pages/constants'
import { useSiteDetails } from '@/features/site/pages/SiteDetails'

export function SiteDetailsRevenue() {
  const navigate = useNavigate()
  const { site, isFetchingSite, setPageConfig, siteDetailsCommonBreadcrumbs } = useSiteDetails()
  const { isLoading, insightRevenuePeriods, legacyRevenuePeriods, marketPrograms, hasRevenueData, hasLegacyData } =
    useRevenueTabsData({ site })

  useEffect(() => {
    if (!isInRevenueAllowedCountry(site.location)) {
      navigate(`/sites/${site.uuid}/contact-info`)
    }
  }, [site.location])

  useEffect(() => {
    setPageConfig({
      title: t('customer_details.tabs.revenue.title'),
      breadcrumbs: siteDetailsCommonBreadcrumbs,
      pageTag: 'site-details-revenue',
      activeTab: SiteDetailsRouteInformation.REVENUE.navigationPath,
    })
  }, [])

  if (!site || isFetchingSite || isLoading) {
    return null
  }

  return (
    <SiteRevenueContent
      hasLegacyData={hasLegacyData}
      hasRevenueData={hasRevenueData}
      insightRevenuePeriods={insightRevenuePeriods}
      legacyRevenuePeriods={legacyRevenuePeriods}
      marketPrograms={marketPrograms}
      site={site}
    />
  )
}
